import { render, staticRenderFns } from "./Offboarding.vue?vue&type=template&id=766793fa"
import script from "./Offboarding.vue?vue&type=script&lang=js"
export * from "./Offboarding.vue?vue&type=script&lang=js"
import style0 from "./Offboarding.vue?vue&type=style&index=0&id=766793fa&prod&lang=scss"
import style1 from "./Offboarding.vue?vue&type=style&index=1&id=766793fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports